import React from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { ListingForm } from "@/components/ListingForm";

export default function CreateListing() {
  const navigate = useNavigate();
  const qc = useQueryClient();

  const create = async (payload) => {
    const listing = await apiFetch("/listings", { method: "POST", body: JSON.stringify(payload) });
    qc.invalidateQueries({ queryKey: ["listings"] });
    qc.invalidateQueries({ queryKey: ["my-listings"] });
    toast.success("Listing published!");
    navigate(`/listing/${listing.id}`);
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6">
      <h1 className="font-display text-2xl font-extrabold text-foreground">Sell an item</h1>
      <p className="mt-1 text-sm text-muted-foreground">Add photos and details to reach thousands of buyers.</p>
      <div className="mt-6">
        <ListingForm onSubmit={create} submitLabel="Publish listing" />
      </div>
    </div>
  );
}
